import React, { useEffect } from "react";
import { Button, Col, Row } from "reactstrap";
import { FaChevronRight } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchContent } from "../../redux/slices/contentSlice";
import { fetchNews } from "../../redux/slices/newsSlice";
import API from "../../api";

const NewsList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const lang = useSelector((state) => state.lang.lang);
  const { dataNews } = useSelector((state) => state.news);
  const { dataContent } = useSelector((state) => state.content);
  useEffect(() => {
    dispatch(fetchContent());
    dispatch(fetchNews());
  }, [dispatch]);

  const newsList = Array.isArray(dataNews) ? dataNews : [];
  const sortedNewsList = [...newsList].sort(
    (a, b) => (a.sort ?? 0) - (b.sort ?? 0)
  );
  let news_all = "";
  if (dataContent) {
    news_all = dataContent.specialField2?.[lang] || "";
  }
  return (
    <div className="news_page">
      <div className="mb-3">
        <strong>{news_all}</strong>
      </div>
      {sortedNewsList.map((news) => (
        <Row className="h-100 m-0 px-0" key={news.id}>
          <Col
            xs={12}
            sm={12}
            md={12}
            lg={4}
            xl={4}
            className="mb-4 mx-0 p-0 h-100"
          >
            <div className="h-100">
              {news.files && news.files.length > 0 && (
                <img
                  src={`${API.BASE}${news.files[0]}`}
                  alt=""
                  className="w-100 h-100"
                />
              )}
            </div>
          </Col>
          <Col xs={12} sm={12} md={8} lg={8} xl={8} className="mb-4 h-100">
            <div className="w-100 h-100" style={{ minHeight: "300px" }}>
              <div>
                <div>
                  <small className="color2 f12">
                    {news.specialField1[lang]}
                  </small>
                </div>
                <div className="mt-2">
                  <strong>{news.title[lang]}</strong>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default NewsList;
